export default "__VITE_ASSET__BlvpmD$y__"